<app-hero-banner
  [title]="'our process'"
  [isFullBanner]="false"
></app-hero-banner>

<div class="process-container">
  @for (step of steps; track $index) {
  <div class="process-step">
    <div class="step-content">
      <div class="step-number">{{ $index + 1 }}</div>
      <div class="step-details">
        <h2>{{ step.title }}</h2>
        <p>{{ step.description }}</p>
      </div>
    </div>
    <div class="step-image">
      <img [src]="step.image" [alt]="step.title" />
    </div>
  </div>
  }
</div>
